


















import { directive as clickaway } from 'vue-clickaway';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Vue, { PropType } from 'vue';
import Modal from '~/components/builders/Base/Modal.vue';
import { CourseraCourse } from '~/models/coursera';
import AboutSection from './AboutSection.vue';
import InstructorSection from './InstructorSection.vue';

export default Vue.extend({
    name: 'CourseModal',
    components: { Modal, AboutSection, InstructorSection },
    directives: {
        onClickaway: clickaway,
    },
    props: {
        course: {
            type: Object as PropType<CourseraCourse>,
            default: null,
        },
    },
    data() {
        return {
            modalElement: null as Element | null,
        };
    },
    methods: {
        handleKeyDown(evt: KeyboardEvent) {
            if (evt.key === 'Escape') this.$emit('close');
        },
        away() {
            this.$emit('close');
        },
    },
    watch: {
        course(value) {
            const modal = this.$refs.modal as Element;
            if (!modal) return;

            if (!!value) disableBodyScroll(modal);
            else enableBodyScroll(modal);
        },
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
});
